import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import customersServices from '@src/services/customers.services';
import { axiosInstance } from '@src/services/api';

export const userCustomersGetList = createAsyncThunk(
  'userCustomersGetList',
  async (body, { rejectWithValue }) => {
    try {
      return await customersServices.userCustomersGetList(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const customerLogosGetList = createAsyncThunk(
  'customerLogosGetList',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      const vouId = body?.vouId ?? 1; // ticket restoran
      if (!customerId && !vouId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      return await customersServices.customerLogosGetList({ customerId: customerId, vouId: vouId });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getCustomerVouList = createAsyncThunk(
  'getCustomerVouList',
  async (body, { getState, rejectWithValue }) => {
    try {
      return await customersServices.customerVouList(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getCustomerVouListForGift = createAsyncThunk(
  'getCustomerVouListForGift',
  async (body, { getState, rejectWithValue }) => {
    try {
      return await customersServices.customerVouList(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  customerList: [],
  customerVou: {},
  customerVouList: [],
  selectedCustomer: {
    customerId: 0,
    customerName: '',
    taxOrIdentificationNumber: '',
    selected: false,
  },
};

export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = { ...action?.payload, selected: true };
      window.customerId = action?.payload?.customerId;
      axiosInstance.defaults.params = {
        customerId: window.customerId,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userCustomersGetList.fulfilled, (state, action) => {
      const customerList =
        action?.payload?.data.length > 0
          ? action?.payload?.data
          : action?.payload?.data?.data || [];
      const length = customerList?.length || 0;
      state.customerList = length > 1 ? customerList : [];
      switch (length) {
        case 0:
          console.log(`selectedCustomer Dönmedi`);
          break;
        default:
          state.selectedCustomer = customerList[0];
          break;
      }
      window.customerId = state.selectedCustomer.customerId;
      axiosInstance.defaults.params = {
        customerId: window.customerId,
      };
      state.selectedCustomer.selected = true;
    });
    builder.addCase(userCustomersGetList.rejected, (state) => {
      state.customerList = [];
      state.selectedCustomer = {};
    });
    builder.addCase(getCustomerVouList.fulfilled, (state, action) => {
      state.customerVou = action?.payload?.data[0] || {};
      state.customerVouList = action?.payload?.data || [];
    });
  },
});

export const { setSelectedCustomer } = customerSlice.actions;
